module.exports = __webpack_public_path__ + "static/media/porfoliov2.65ad6acd.jpg";